import React from 'react';
import PropTypes from 'prop-types';
import CurrentPage, { getCurrentPageProps } from '@components/pages/currentPage/currentPage';
import LandingPage from '@components/pages/landing/landing';
import { wrapper } from '@redux/store';
import { appSetPageData } from '@redux/actions/app';

const Page = props => {
  const { PAGE_TYPE, type } = props;

  if (PAGE_TYPE === 'LANDINGPAGE' && type === 'landingpageSimple') {
    return <LandingPage {...props} />;
  }

  return <CurrentPage data={props} />;
};

export default Page;

Page.propTypes = {
  data: PropTypes.shape().isRequired,
  PAGE_TYPE: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export const getServerSideProps = wrapper.getServerSideProps(
  store =>
    async ({ locale, resolvedUrl }) => {
      const props = await getCurrentPageProps({ locale, resolvedUrl });

      await store.dispatch(appSetPageData(props));

      return {
        props,
        notFound: !props?.PAGE_TYPE || !!props?.error
      };
    }
);
